import React from 'react';
import {
  Section,
  SettingsSectionBox,
  SettingsSectionLabel,
  SettingToggle,
} from '@views/Settings/components';
import styles from './Advanced.module.scss';
import useEnabledNotifications from '../use-enabled-notifications';

export default function Advanced() {
  const { enabledNotifications, toggleNotification } = useEnabledNotifications();

  return (
    <Section>
      <SettingsSectionLabel>Advanced</SettingsSectionLabel>
      <SettingsSectionBox className={styles.container}>
        <SettingToggle
          title="Quality Filter"
          checked={!enabledNotifications['include_people_without_information']}
          name="include_people_without_information"
          onChange={() => toggleNotification('include_people_without_information')}
        />
        <p>
          Filter less actionable notifications like meeting reminders for people you’ve met recently
          or profiles with sparse information
        </p>
      </SettingsSectionBox>
    </Section>
  );
}
